<template>
  <div>
    <div class="filter-row">
      <div class="row-item" @click="filterClick(null, true)" :class="{ selected: selectedFilter == allOrdersFilter}">{{allOrdersFilter}}</div>
      <div v-for="acceptionOption in acceptionOptions" :key="'acceptionOption'+acceptionOption.id" class="row-item" @click="filterClick(acceptionOption, true)" :class="{ selected: selectedFilter == acceptionOption}">
        OS {{ acceptionOption.filterName }}
      </div>
      <div v-for="accountabilityStatusOption in accountabilityStatusOptions" :key="'accountabilityStatusOption'+accountabilityStatusOption.id" class="row-item" @click="filterClick(accountabilityStatusOption, false)" :class="{ selected: selectedFilter == accountabilityStatusOption}">
        Prestação {{ accountabilityStatusOption.filterName }}
      </div>
    </div>

    <h3 id="list-os" class="mt-4">Minhas Ordens</h3>
    <hr/>

    <b-pagination v-model="filter.page" :total-rows="page.totalElements" :per-page="page.size" id="pagination-os"></b-pagination>

    <b-row v-if="page" class="footer-pagination-os">
      <b-col>
        <div>Mostrando {{page.numberOfElements}} de um total de {{page.totalElements}} registros</div>
      </b-col>
    </b-row>

    <div class="so-mobile">
      <div v-for="serviceOrder in serviceOrders" :key="serviceOrder.id" class="so-card">
        <b-card no-body>
          <span class="so-header">OS {{ serviceOrder.fileNumber }}</span>
          <b-tabs card justified>
            <b-tab title="Geral">
              <b-card-text>
                <h6 class="so-Number"><b>{{ serviceOrder.fileNumber }} - {{ serviceOrderDate(serviceOrder) }}</b></h6>
                <p class="so-name">
                  {{ serviceOrder.file.pax }}
                  <span v-if="isFileCancelled(serviceOrder.file)"> - <b class="cancelled-status">{{ serviceOrder.file.status.name }}</b></span>
                </p>
                <span class="so-info"><b>Status:</b><br/>{{ serviceOrder.acceptationGuideStatus.name }}</span><br/>
                <span class="so-info" v-if="isAccepted(serviceOrder)"><b>Prestação de conta:</b><br/>{{ getGuideAccountabilityStatus(serviceOrder).name }}</span><br/><br/>
                <span class="so-info" v-if="serviceOrder.attachmentPaths.length > 0">
                  <b>Anexos:</b>
                  <div v-for="attach in serviceOrder.attachmentPaths" :key="attach" class="attachment">
                    <a href="#" @click.prevent="downloadfile(attach)">
                      {{baseFileName(attach)}}
                    </a>
                  </div>
                </span>
                <hr/>
                <div class="actions">
                  <i v-if="!isFileCancelled(serviceOrder.file)" class="material-icons actions" title="Visualizar Ordem de Serviço"
                    @click.stop="openOsView(serviceOrder)">receipt</i>
                  <i class="material-icons actions" title="Visualizar Logs de Alteração"
                    @click.stop="openChangeLog(serviceOrder)">history</i>
                  <span class="material-icons actions"
                    :class="{ 'unseen-messages': serviceOrder.chatGroup.hasUnseenMessages() }" title="Chat com handling"
                    @click.stop="openChat(serviceOrder)">chat</span>
                  <i v-if="!isFileCancelled(serviceOrder.file) && canShowAccountability(serviceOrder)" class="material-icons actions" title="Prestar Contas"
                    @click.stop="openAccountability(serviceOrder)">attach_money</i>

                  <component
                    :is="hasInvoice(serviceOrder) ? 'a' : 'i'"
                    v-if="(isAccountabilityAuthorized(serviceOrder) || isAccountabilityPaid(serviceOrder)) && isGuideInvoicePayment(serviceOrder)"
                    @click.stop="openInvoice(serviceOrder)"
                    href="#"
                    class="material-icons actions"
                    title="Nota Fiscal"
                    >description
                  </component>
                  </div>
              </b-card-text>
            </b-tab>
            <b-tab title="Serviços" :active="hasPendingBooking(serviceOrder)">
              <b-card-text>
                <div class="batch-buttons-box">
                  <form-button v-if="canBulkUpdateStatus(filteredBookings(serviceOrder))" @click="changeBookingsStatus(filteredBookings(serviceOrder), GuideAcceptanceStatus.ACCEPTED)" variant="success" size="sm" title="Aceitar Todos" />
                  <form-button v-if="canBulkUpdateStatus(filteredBookings(serviceOrder))" @click="changeBookingsStatus(filteredBookings(serviceOrder), GuideAcceptanceStatus.REFUSED)" variant="danger" size="sm" title="Recusar Todos" />
                </div>
                <hr>
                <div v-for="booking, i in filteredBookings(serviceOrder)" :key="booking.id">
                  <p class="so-Number"><b>{{ booking.booking.bookingNumber }} - {{ booking.booking.date }}</b></p>
                  <p class="so-name">
                    {{ booking.booking.productName }}
                    <span v-if="isBookingCancelled(booking.booking.status.id)"> - <b class="cancelled-status">{{ booking.booking.status.name }}</b></span>
                  </p>
                  <p class="so-info"><b>Pick-up:</b> {{ booking.pickup }}</p>
                  <p class="so-info"><b>Status:</b> {{ booking.guideStatus.name }}</p>

                  <div class="actions">
                    <form-button class="action-button accepted" size="auto" variant="success"
                      v-if="!isBookingCancelled(booking.booking.status.id) && !isStatus(booking, GuideAcceptanceStatus.REFUSED) && !isStatus(booking, GuideAcceptanceStatus.ACCEPTED)"
                      @click="!isStatus(booking, GuideAcceptanceStatus.ACCEPTED) && changeBookingStatus(booking, GuideAcceptanceStatus.ACCEPTED)" title="Aceitar"/>
                    <form-button class="action-button refused" size="auto" variant="danger"
                      v-if="!isBookingCancelled(booking.booking.status.id) && !isStatus(booking, GuideAcceptanceStatus.REFUSED) && !isStatus(booking, GuideAcceptanceStatus.ACCEPTED)"
                      :disabled="canRefuse(booking, serviceOrder)"
                      @click="!isStatus(booking, GuideAcceptanceStatus.REFUSED) && changeBookingStatus(booking, GuideAcceptanceStatus.REFUSED)" title="Recusar"/>
                    <form-button class="action-button refused" size="auto" variant="danger"
                      v-if="!isBookingCancelled(booking.booking.status.id) && isStatus(booking, GuideAcceptanceStatus.ACCEPTED) && isAccountabilityPending(serviceOrder)"
                      :disabled="canRefuse(booking, serviceOrder)"
                      @click="!isStatus(booking, GuideAcceptanceStatus.REFUSED) && changeBookingStatus(booking, GuideAcceptanceStatus.REFUSED)" title="Cancelar"/>
                  </div>
                  <hr v-if="i < filteredBookings(serviceOrder).length - 1">
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>

    <b-row v-if="page" class="footer-pagination-os">
      <b-col>
        <div>Mostrando {{page.numberOfElements}} de um total de {{page.totalElements}} registros</div>
      </b-col>
    </b-row>

    <service-order-view ref="osView"/>

    <blumar-chat ref="chat"/>
    <change-log-modal ref="changeLog"/>
    <accountability ref="accountability"/>
    <invoice ref="invoice"/>
  </div>
</template>

<script>
import BaseListingPage from '../shared/BaseListingPage.vue';
import BaseList from '../shared/BaseList.vue';
import ServiceOrderService from '../../service/ServiceOrderService';
import StorageService from '../../service/StorageService';
import LabeledInput from '../shared/LabeledInput.vue';
import moment, { min } from 'moment';
import ServiceOrderView from './ServiceOrderView.vue';
import BlumarChat from '../shared/blumar-chat/BlumarChat.vue';
import ChatGroup from '../shared/blumar-chat/ChatGroup';
import { fetchModel, requestAction, downloadFile, baseFileName } from '../../utils';
import ChangeLogModal from './ChangeLogModal.vue';
import Accountability from './accountability/Accountability.vue';
import { AccountabilityStatus } from '../../enums/AccountabilityStatus';
import Invoice from './Invoice.vue';
import { GuideAcceptanceStatus } from '../../enums/GuideAcceptanceStatus';
import { GuidePaymentType } from '../../enums/GuidePaymentType';
import ServiceOrderBookingService from '../../service/ServiceOrderBookingService';
import { connectChats, disconnectChats } from '../../chat-utils';
import FormButton from '../shared/FormButton';
import { ReservationStatus } from '../../enums/ReservationStatus';

export default {
  components: { BaseListingPage, BaseList, LabeledInput, ServiceOrderView, ChangeLogModal, BlumarChat, Accountability, Invoice, FormButton },
  data() {
    return {
      service: new ServiceOrderService(),
      serviceOrderBookingService: new ServiceOrderBookingService(),
      storageService: new StorageService(),
      serviceOrders: [],
      columns: [
        { key: 'see-more', label: '', class: 'see-more' },
        { key: 'fileNumber', label: 'File' },
        { key: 'file.pax', label: 'Pax' },
        { key: 'firstServiceDate', label: 'Data do 1° serviço', formatter: (v, k, item) => min(item.bookings.map(b => moment(b.booking.date, 'DD/MM/YYYY'))).format('DD/MM/YYYY')},
        { key: 'acceptationGuideStatus.name', label: 'Status Aceitação'},
        { key: 'accountability-status', label: 'Prestação de conta', formatter: (v, k, item) => this.getGuideAccountabilityStatus(item).name },
      ],
      socket: null,
      subscriptions: [],
      GuideAcceptanceStatus: GuideAcceptanceStatus,
      acceptionOptions: [
        GuideAcceptanceStatus.WAITING,
        GuideAcceptanceStatus.ACCEPTED
      ],
      accountabilityStatusOptions: [
        AccountabilityStatus.PENDING,
        AccountabilityStatus.CONCLUDED,
        AccountabilityStatus.REFUSED,
        AccountabilityStatus.APPROVED,
        AccountabilityStatus.AUTHORIZED,
        AccountabilityStatus.PAID,
      ],
      allOrdersFilter: 'Todas',
      filter: this.defaultFilter(),
      page: {},
      sortDesc: true,
      selectedFilter: GuideAcceptanceStatus.WAITING,
      chats: null
    }
  },
  mounted() {
    this.filterClick(GuideAcceptanceStatus.WAITING, true);
  },
  destroyed() {
    disconnectChats(this.chats, this.socket);
  },
  methods: {
    baseFileName,
    filteredBookings(serviceOrder) {
      return serviceOrder && serviceOrder.bookings ? serviceOrder.bookings.filter(booking => booking.guide && booking.guide.id === this.$store.state.user.id) : [];
    },
    serviceOrderDate(serviceOrder) {
      return serviceOrder && serviceOrder.bookings? min(serviceOrder.bookings.map(booking => moment(booking.booking.date, 'DD/MM/YYYY'))).format('DD/MM/YYYY') : '';
    },
    canRefuse(booking, serviceOrder) {
      const guideAccountability = serviceOrder.accountabilities.find(a => a.guide.id === this.$store.state.user.id);
      const wasAccountabilityConcluded = guideAccountability && guideAccountability.status.id !== AccountabilityStatus.PENDING.id;
			return this.isStatus(booking, this.GuideAcceptanceStatus.REFUSED) && !wasAccountabilityConcluded;
    },
    defaultFilter() {
      return {
        accountabilityStatusId: null,
        guideId: this.$store.state.user.id,
        page: 1,
        size: 10,
        sortBy: 'file.fileCheckin.checkin',
        sortDirection: 'asc'
      };
    },
    openOsView(serviceOrder) {
      this.$refs.osView.open(serviceOrder.file, serviceOrder);
    },
    openChangeLog(serviceOrder) {
      this.$refs.changeLog.open(serviceOrder)
    },
    openChat(serviceOrder) {
      this.$refs.chat.open(serviceOrder.chatGroup, "File " + serviceOrder.fileNumber);
    },
    async fetchServiceOrders() {
      let data = await fetchModel('ordens de serviço', () => this.service.filter(this.filter));
      this.page = data.content.map(os => {
        let chatGroup = os.chatGroups.find(chat => chat.guide.id === this.$store.state.user.id);
        os.chatGroup = new ChatGroup(chatGroup.chatGroup);
        return os;
      });
      this.page = data;
      this.serviceOrders = this.page.content;
      return data;
    },
    async changeBookingStatus(booking, status) {
      let verb = status.name === GuideAcceptanceStatus.ACCEPTED.name? 'aceitar': 'recusar';
      if (confirm(`Deseja realmente ${verb} este serviço?`)) {
        let success = `Serviço ${status.name}`;
        let failure = `Falha ao ${verb} serviço`;
        await requestAction(success, failure, this.serviceOrderBookingService.updateStatus(booking.id, status));
        booking.guideStatus = status;
      }
		},
    async changeBookingsStatus(bookings, status) {
      let verb = status.name === GuideAcceptanceStatus.ACCEPTED.name? 'aceitar': 'recusar';
      if (confirm(`Deseja realmente ${verb} estes serviços?`)) {
        let success = `Serviços ${status.name}s`;
        let failure = `Falha ao ${verb} serviços`;
        await requestAction(success, failure, this.serviceOrderBookingService.updateStatuses(bookings.map(b => b.id), status));
        bookings.forEach(b => b.guideStatus = status);
      }
		},
    openAccountability(serviceOrder) {
      this.$refs.accountability.open(serviceOrder);
    },
    hasAcceptedBookings(serviceOrder) {
      return this.guideBookings(serviceOrder).some(b => this.isStatus(b, GuideAcceptanceStatus.ACCEPTED));
    },
    hasLastServiceDateElapsed(serviceOrder) {
      let lastDate = moment.max(this.acceptedGuideBookings(serviceOrder).map(b => moment(b.booking.date, "DD/MM/YYYY")));
      return lastDate.isBefore(moment().startOf("days"));
    },
    hasPendingBooking(serviceOrder) {
      return this.guideBookings(serviceOrder).some(b => this.isStatus(b, GuideAcceptanceStatus.WAITING));
    },
    canShowAccountability(serviceOrder) {
      return this.hasAcceptedBookings(serviceOrder) && this.hasLastServiceDateElapsed(serviceOrder) && !this.hasPendingBooking(serviceOrder)
    },
    acceptedGuideBookings(serviceOrder) {
      return this.guideBookings(serviceOrder).filter(b => this.isStatus(b, GuideAcceptanceStatus.ACCEPTED));
    },
		guideBookings(serviceOrder) {
			return serviceOrder?  serviceOrder.bookings.filter(b => b.guide && b.guide.id === this.$store.state.user.id) : [];
		},
    getGuideAccountability(serviceOrder) {
      return serviceOrder && serviceOrder.accountabilities ? this.findGuideAccountability(serviceOrder.accountabilities || []) : null;
    },
    getGuideAccountabilityStatus(serviceOrder) {
      let accountability = this.getGuideAccountability(serviceOrder);
      return accountability ? accountability.status : AccountabilityStatus.PENDING;
    },
    findGuideAccountability(accountabilities) {
      return accountabilities.find(acc => acc.guide.id === this.$store.state.user.id);
    },
    isAccountabilityAuthorized(serviceOrder) {
      let status = this.getGuideAccountabilityStatus(serviceOrder);
      return status.id === AccountabilityStatus.AUTHORIZED.id;
    },
    isGuideInvoicePayment(serviceOrder) {
      let accountability = this.getGuideAccountability(serviceOrder);
      let paymentType = accountability.guide.paymentType;
      return !paymentType || paymentType.id === GuidePaymentType.INVOICE.id;
    },
    openInvoice(serviceOrder) {
      let accountability = this.getGuideAccountability.bind(this)(serviceOrder);
      if (accountability)
        this.$refs.invoice.open(accountability);
    },
    hasInvoice(serviceOrder) {
      let accountability = this.getGuideAccountability(serviceOrder);
      return accountability && !!accountability.invoice && accountability.invoice.filePath;
    },
    isStatus(booking, status) {
			return booking && booking.guideStatus && booking.guideStatus.id === status.id;
		},
    clearFilter() {
			this.filter = this.defaultFilter.bind(this)();
		},
    async filterClick(val, isAcception) {
      this.clearFilter();
      if(!val)
        this.selectedFilter = this.allOrdersFilter;
      else {
        this.selectedFilter = val;
        if(isAcception)
          this.filter.guideStatusId = val.id;
        else
          this.filter.accountabilityStatusId = val.id;
      }
      await this.fetchServiceOrders();
      await this.loadChats();
    },
    async loadChats() {
      this.$refs.chat.close();
      if (this.chats)
        disconnectChats(this.chats);
      var chats = this.serviceOrders.map(os => os.chatGroup);
      this.chats = connectChats(chats);
    },
    isAccountabilityPaid(serviceOrder) {
      let status = this.getGuideAccountabilityStatus(serviceOrder);
      return status.id === AccountabilityStatus.PAID.id;
    },
    isAccountabilityPending(serviceOrder) {
      let status = this.getGuideAccountabilityStatus(serviceOrder);
      return status.id === AccountabilityStatus.PENDING.id;
    },
    isAccepted(serviceOrder){
      return serviceOrder.acceptationGuideStatus.id === this.GuideAcceptanceStatus.ACCEPTED.id
    },
		downloadfile(filePath) {
			return downloadFile(filePath, path => this.storageService.downloadFile(path));
		},
    isBookingCancelled(bookingStatusId) {
      return bookingStatusId == ReservationStatus.XL.id;
    },
    isFileCancelled(file) {
			return file.status.id === ReservationStatus.XL.id;
		},
    canBulkUpdateStatus(bookings) {
      return bookings.length >= 2 && !bookings.find(b => !this.isStatus(b, GuideAcceptanceStatus.WAITING)) && !bookings.find(b => this.isBookingCancelled(b.booking.status.id));
    }
  },
  watch: {
    'filter.page': {
      handler() {
        this.fetchServiceOrders();
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.form-group {
  & >>> legend {
    color: white;
  }

  select, & >>> .bv-no-focus-ring {
    width: 100%;
  }
}

.service-order-page >>> .see-more {
  width: 50px;
  cursor: pointer;
}

.unseen-messages {
  color: #0fff2399;
}

.so-mobile {
  display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	grid-gap: 30px;
	padding: 30px;
}

.so-card {
  max-width: 500px;
}

.so-header {
  font-weight: bold;
  padding-left: 1.25rem;
  padding-top: 5px;
  padding-bottom: 3px;
}

#list-os, #pagination-os, .footer-pagination-os {
  margin-left: 8%;
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.filter-row {
  width: 100%;
  background-color: #042035;
  display: flex;
  flex-direction: row;
  gap: 20px;
  overflow-x: auto;
  padding: 3% 8% 0% 8%;
  white-space: nowrap;

  .row-item {
    color: #9aa0a6;
    cursor: pointer;
  }

  .selected {
    border-bottom: 2px solid #ffffff;
    padding-bottom: 3%;
    color: white;
  }
}

.cancelled-status {
  color: red;
}

.filter-row::-webkit-scrollbar {
  display: none;
}

.batch-buttons-box {
  display: flex;
  justify-content: space-around;
  margin: 0% 0% 1.25rem;
  flex-wrap: wrap;
  gap: 1px;
}

.accepted[disabled="disabled"], .refused[disabled="disabled"] {
  cursor: default;
    &:hover {
      font-weight: normal;
  }

  @media screen and (max-width: 900px) {
    .so-mobile {
      display: block;
    }
  }
}

@media screen and (min-width: 900px) {
  .filter-row {
    padding: 1rem 2rem 0rem 2rem;

    .selected{
      padding-bottom: 1%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/os/ServiceOrders.vue